export default __webpack_public_path__ + "static/media/Cartão Crédito.6c54a751.svg";